/**************************************************
 * Nombre:       Dialogo_Contrato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Contrato from "../Formularios/Formulario_Contrato";
import {useContext, useEffect, useRef, useState} from "react";
import {usuarioContext} from "../../App";
import {Task} from '@mui/icons-material'
import {crearContrato} from "../../CodigoCliente/Contratos/crearContrato";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../Recursos/logo_redondo.svg";
import {obtenerTotalDepositos} from "../../CodigoCliente/Depositos/obtenerTotalDepositos";
import {useLocation, useNavigate} from "react-router";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";
import {entregarBonos} from "../../CodigoCliente/Bonos/entregarBonos";
import debounce from 'lodash.debounce'


const Dialogo_Contrato = ({cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const navigate = useNavigate();
    const location = useLocation()
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })
    const [cargando, setCargando] = useState(false)

    const recargarPagina = () => {
        let loc = obtenerSeccion(location.pathname)
        if (loc === 'Contratos') {
            window.location.reload()
        } else {
            navigate('/Contratos')
        }
    }



    const clickBoton = () =>{
        setCargando(true)
        subirDatos().then(() =>{
            setCargando(false)
        })
    }


    const subirDatos = async () => {



        let entidad = await obtenerEntidad()


        if (entidad.valor < 30) {
            terminar({aviso: 'El valor mínimo de contrato es de $30 USD', variante: 'error'})
            return
        }

        let totalDepositos = await obtenerTotalDepositos(cData.usuario.id)

        if (entidad.valor > totalDepositos) {
            terminar({aviso: 'No posees el suficiente dinero en la wallet de depósito', variante: 'error'})
            return
        }
        if (cargando) {
            return;
        }
        setCargando(true)

        iniciarCarga('Creando contrato')
        let dox = await crearContrato({entidad: entidad, usuario: cData.usuario, terminar: terminar})
        if (dox.res) {


            await entregarBonos({
                cuenta: cData.usuario,
                idContrato: dox.data.id,
                valorContrato: entidad.valor,
                hash: dox.hash,
                consecutivo: dox.data.consecutivo
            })


            terminar({aviso: 'Contrato creado con exito'})
            recargarPagina()

        } else {
            terminar({aviso: dox.data, variante: 'error'})
        }

        setCargando(false)

    }




    useEffect(() => {

        let obj = {
            nombre: cData.usuario.nombre,
            codigo: cData.usuario.codigo,
            correo: cData.usuario.correo,
        }

        setEntidad(obj)

    }, [cData.usuario])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formulario_Contrato props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3, mb: 2}}>
                <Button
                    loading={cargando}
                    onClick={(e) => clickBoton(e)}
                    onDoubleClick={() => {
                    }}
                    startIcon={<Task/>}>Generar contrato</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Contrato    